"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareStickyBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CardSelected = require("./CardSelected");
var _NoCardSelected = require("./NoCardSelected");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var CompareStickyBar = exports.CompareStickyBar = function CompareStickyBar(_ref) {
  var activeCards = _ref.activeCards,
    addCard = _ref.addCard,
    addCardDtm = _ref.addCardDtm,
    addCardText = _ref.addCardText,
    columnCount = _ref.columnCount,
    iconColor = _ref.iconColor,
    namespace = _ref.namespace,
    removeCard = _ref.removeCard,
    styles = _ref.styles,
    linkComponent = _ref.linkComponent;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('compare-sticky-bar', styles.compareStickyBar)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "compare-sticky-bar__content"
  }, _toConsumableArray(Array(columnCount).keys()).map(function (index) {
    var card = activeCards[index];
    if (card) {
      return /*#__PURE__*/_react["default"].createElement(_CardSelected.CardSelected, {
        key: index,
        card: card,
        iconColor: iconColor,
        namespace: namespace,
        removeCard: removeCard,
        linkComponent: linkComponent
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_NoCardSelected.NoCardSelected, {
      key: index,
      addCard: addCard,
      addCardDtm: addCardDtm,
      addCardText: addCardText,
      iconColor: iconColor,
      namespace: namespace
    });
  })));
};
CompareStickyBar.propTypes = {
  activeCards: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  addCard: _propTypes["default"].func.isRequired,
  addCardDtm: _propTypes["default"].objectOf(_propTypes["default"].string),
  addCardText: _propTypes["default"].string,
  columnCount: _propTypes["default"].number,
  iconColor: _propTypes["default"].string,
  namespace: _propTypes["default"].string,
  removeCard: _propTypes["default"].func.isRequired,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  linkComponent: _propTypes["default"].func
};
CompareStickyBar.defaultProps = {
  addCardDtm: {},
  addCardText: undefined,
  columnCount: 3,
  iconColor: '#00175A',
  namespace: '',
  styles: {},
  linkComponent: undefined
};